var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('i',{class:{'icon-bookmark21': _vm.wishlistCount, 'icon-bookmark-empty': !_vm.wishlistCount}}),_vm._v(" "),(_vm.wishlistCount)?_c('span',{staticClass:"badge"},[_vm._v(_vm._s(_vm.wishlistCount))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }